
import React, { useRef } from 'react';

const privacidad = () => {

    

    

    return (
        <div className="container">

    

           <h3><b>Políticas de Uso de la Aplicación APATECH TOOL</b></h3>

           <p> Estas Políticas de Uso establecen los términos y condiciones bajo los cuales puedes acceder y utilizar la aplicación APATECH TOOL ("nosotros", "nuestro/a" o "la Aplicación"). Al utilizar nuestra aplicación, aceptas cumplir con estas políticas y términos.
</p>
            <h5><b>Contenido de la Aplicación</b></h5>

           1. El contenido disponible en APATECH TOOL, incluyendo pero no limitado a textos, imágenes, videos y otros materiales, está protegido por derechos de autor y otras leyes de propiedad intelectual.
            <p>  2. No puedes copiar, reproducir, distribuir, transmitir, modificar o utilizar el contenido de la aplicación con fines comerciales sin nuestro permiso previo por escrito.
        </p>
            <h5><b> Uso Adecuado</b></h5>

            <p> 1. Al utilizar nuestra aplicación, te comprometes a no realizar las siguientes actividades:
            </p> <p>  - Publicar contenido ofensivo, difamatorio, obsceno o ilegal.
            </p> <p>  - Realizar acciones que puedan afectar negativamente la experiencia de otros usuarios.
            </p> <p>  - Intentar acceder a áreas no autorizadas de la aplicación o a sistemas relacionados.
            </p> <p>   - Utilizar la aplicación para fines ilegales o no autorizados. </p>

            <h5><b>Cuentas de Usuario</b></h5 >

              1. Al crear una cuenta en nuestra aplicación, eres responsable de mantener la confidencialidad de tus credenciales y de cualquier actividad que ocurra bajo tu cuenta.

               <p>  2. Nos reservamos el derecho de suspender o cancelar cuentas que infrinjan estas políticas o que sean utilizadas de manera inapropiada o ilegal.
                </p>
            <h5><b> Actualizaciones y Cambios</b ></h5 >

            Nos reservamos el derecho de realizar cambios en la aplicación, sus características y estas políticas en cualquier momento y sin previo aviso.

            <h5><b>Limitación de Responsabilidad</b ></h5 >

            1. La aplicación se proporciona "tal cual", y no garantizamos que sea libre de errores o que cumpla con tus expectativas.

          <p> 2. No seremos responsables por cualquier daño directo, indirecto, incidental, especial o consecuente que resulte del uso de la aplicación.
</p> 
            <h5><b> Contacto</b ></h5 >

            Si tienes preguntas o inquietudes sobre estas Políticas de Uso, puedes ponerte en contacto con nosotros en <a href={"mailto:info@apatech.com.do"} target="_blank">info@apatech.com.do</a>.

            Fecha de entrada en vigencia: 10/01/2023

           
        </div>

        )
}

export default privacidad